export const obtenerRuleId = (regla) => String(regla?.idRegla || regla?.ruleId || "").trim();

export const reglaActiva = (regla) => {
  if (regla?.activo === false) return false;
  const status = String(regla?.status || "").trim().toUpperCase();
  if (status === "INACTIVO" || status === "DESHABILITADA" || status === "DESHABILITADO") return false;
  return true;
};

export const resolverRelacionInversaLocal = ({ currentRuleId, reglaActual, reglas = [] } = {}) => {
  const ruleId = String(currentRuleId || reglaActual?.ruleId || reglaActual?.idRegla || "").trim();
  if (!ruleId) return null;

  const all = Array.isArray(reglas) ? reglas : [];
  const byId = (id) => all.find((r) => obtenerRuleId(r) === String(id || "").trim());
  const fromDescBase = (rule) => {
    const desc = String(rule?.descripcion || "");
    const match = desc.match(/AUTO_INVERSA_ABM\|BASE=([^\]\s]+)/);
    return match?.[1] ? String(match[1]).trim() : "";
  };

  const esActualInversa = ruleId.endsWith("_INV");
  const baseId = esActualInversa ? ruleId.slice(0, -4) : (fromDescBase(reglaActual) || ruleId);
  const currentRule = byId(ruleId) || reglaActual || null;

  let pareja = null;
  if (esActualInversa) {
    pareja = byId(baseId);
  } else {
    pareja = byId(`${baseId}_INV`);
    if (!pareja) {
      pareja = all.find((r) => {
        const rid = obtenerRuleId(r);
        if (!rid || rid === ruleId) return false;
        return fromDescBase(r) === baseId;
      });
    }
  }

  if (!pareja) return null;

  return {
    currentRule,
    parejaRule: pareja,
    currentRuleId: ruleId,
    parejaRuleId: obtenerRuleId(pareja),
    esActualInversa,
    parejaActiva: reglaActiva(pareja),
  };
};
